import {useQuery} from '@tanstack/react-query';
import {PaidGigDetails} from '@/types/paidGig';
import paidGigsFetchers from '@/api/fetchers/paidGigs';

export const PAID_GIG_QUERY_KEY = 'paidGig';

function usePaidGigQuery(paidGigId: string | null) {
  return useQuery<PaidGigDetails>({
    queryKey: [PAID_GIG_QUERY_KEY, paidGigId],
    queryFn: () => paidGigsFetchers.details(paidGigId as string),
    enabled: !!paidGigId,
    refetchOnWindowFocus: false,
  });
}

export default usePaidGigQuery;
